import {useState, useEffect} from 'react';
  const useDidMount =()=>{
    const [firstRender, setFirstRender] = useState(true);
    useEffect(()=>setFirstRender(false),[]);
    return !firstRender;
}
export default useDidMount